/* eslint-disable no-unused-vars */
import React from 'react';
import { ArrowDown, ArrowRightForSelectedGroup } from 'assets/icons';
import { Checkbox } from 'components';
import * as S from './ParentRow.styled';

export const ParentRow = ({
  isOpenedGroup,
  openCloseGroup,
  name,
  id,
  isGroupChecked,
  columnsList,
  handleToggleGroup,
}) => {
  return (
    <S.Row>
      <S.ArrowIconWrapper isOpen={isOpenedGroup(name)} onClick={() => openCloseGroup(name)}>
        {isOpenedGroup(name) ? <ArrowDown /> : <ArrowRightForSelectedGroup />}
      </S.ArrowIconWrapper>
      <Checkbox
        isChecked={isGroupChecked(columnsList, name)}
        id={id}
        name={name}
        onChange={() => handleToggleGroup(columnsList, name)}
        isOpenGroup
        label={name}
      />
    </S.Row>
  );
};
